import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddConsentTemplate = () => {
  return usePost({
    url: ApiRoutesEnum.addConsentTemplate,
    // NOTE: `updater` needs to be disabled to prevent overriding the consent template list with a single object
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updater: () => {},
  });
};
